import { useState, useEffect } from 'react';
import { fetchProject, fetchProjectKmlData } from '../../../utils/api';

/**
 * @param {string|number|null} projectId
 * @param {object|null} preloadedProject - 上位コンポーネントが既に取得済みのプロジェクト。
 *   指定された場合はプロジェクトの再フェッチをスキップし、KMLデータのみ必要に応じて取得する。
 */
export function useProjectDetails(projectId, preloadedProject = null) {
    const [project, setProject] = useState(preloadedProject);
    const [kmlData, setKmlData] = useState(null);
    const [loading, setLoading] = useState(!preloadedProject);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!projectId) {
            setProject(null);
            setKmlData(null);
            setLoading(false);
            return;
        }

        const loadProject = async () => {
            try {
                setLoading(true);
                setError(null);

                // preloadedProject が渡されている場合はプロジェクト取得をスキップ
                const projectData = preloadedProject ?? await fetchProject(projectId);
                setProject(projectData);

                // KMLが有効な場合のみKMLデータを取得
                if (projectData?.use_kml) {
                    try {
                        const kmlData = await fetchProjectKmlData(projectId);
                        setKmlData(kmlData);
                    } catch (kmlError) {
                        console.error('KMLデータ取得エラー:', kmlError);
                        setKmlData(null);
                    }
                } else {
                    setKmlData(null);
                }
            } catch (err) {
                console.error('プロジェクト取得エラー:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        loadProject();
    // preloadedProject は意図的に依存配列から除外: 初回マウント時の値のみ使用する
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectId]);

    return {
        project,
        kmlData,
        loading,
        error,
        useKml: project?.use_kml || false
    };
}
